<template>
  <!-- Modal -->
  <div class="modal fade" data-backdrop="static" id="NewAccidentIncident"  role="dialog"
       aria-labelledby="NewAccidentIncidentTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <form class="modal-content" @submit.prevent="addAccidentIncident">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold text-uppercase" id="NewAccidentIncidentTitle">Add Accident / Incident Report</h5>
        </div>
        <div class="modal-body text-left">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="VesselList" class="font-weight-bold" style="font-size: 14px;">Vessel<span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
                <select class="form-control form-control-sm text-uppercase" id="VesselList" v-model="newReport.vessel_id" required>
                  <option :value="null" disabled>—— Select Vessel ——</option>
                  <option v-for="vessel in vesselKeys"
                          :key="vessel.id"
                          :value="vessel.id">
                    {{ vessel.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="ReportTitle" class="font-weight-bold" style="font-size: 14px;">Report Title<span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
                <textarea class="form-control form-control-sm" id="ReportTitle" rows="3" v-model="newReport.title" required></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-8 col-lg-8">
              <div class="form-group">
                <label for="EventType" class="font-weight-bold" style="font-size: 14px;">Type of Event<span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
                <select class="form-control form-control-sm text-uppercase" id="EventType" v-model="newReport.eventClass" required>
                  <option :value="null" disabled>—— Select Type of Event ——</option>
                  <option class="text-uppercase" v-for="event in eventOneKeys" :key="event.id" :value="event.id">
                    {{ event.code }}) {{ event.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
              <div class="form-group">
                <label for="EventClass" class="font-weight-bold" style="font-size: 14px;">
                  Event Class
                  <font-awesome-icon
                    icon="question-circle"
                    data-toggle="modal"
                    style="cursor:pointer"
                    data-target="#eventClassDescription"
                  /><span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
                <select class="form-control form-control-sm text-uppercase" id="EventClass" v-model="newReport.eventClassImpact" required>
                  <option :value="null" disabled>— Select Event Class —</option>
                  <option class="text-uppercase" v-for="event in eventImpactKeys" :key="event.id" :value="event.id">
                    {{ event.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-4">
              <div class="form-group">
                <label for="EventDate" class="font-weight-bold" style="font-size: 14px;">Event Date<span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
                <input type="date" :min="minimumDate"  :max="currentDate" class="form-control form-control-sm" id="EventDate" v-model="newReport.eventDate" required>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
              <div class="form-group">
                <label for="LocalTime" class="font-weight-bold" style="font-size: 14px;">Local Time<span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
                <input type="time" class="form-control form-control-sm" id="LocalTime" v-model="newReport.localTime" required>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
              <div class="form-group">
                <label for="isConfidential" class="font-weight-bold" style="font-size: 14px;">Confidential Report?<span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
                <select class="form-control form-control-sm text-uppercase" id="isConfidential" v-model="newReport.is_confidential_report">
                  <option :value="true">YES</option>
                  <option :value="false">NO</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <label for="ManagementOffice" class="font-weight-bold" style="font-size: 14px;">Management Branch Office<span class="text-danger font-weight-bold" style="font-size: 14px;"> *</span></label>
              <select class="form-control form-control-sm text-uppercase" id="ManagementOffice" v-model="newReport.managementOffice" @change="changeManagementBranchCompany()" required>
                <option :value="office.id" v-for="office in mngmntOfficeKeys">
                  {{ office.name | toUpper }}
                </option>
              </select>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <label for="ManagementOffice" class="font-weight-bold" style="font-size: 14px;">Management Branch Company</label>
              <input type="text" id="ManagementOffice" class="form-control form-control-sm text-uppercase" v-model="newReport.managementCompany" readonly>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" @click.prevent="cancelAdd">Cancel</button>
          <button type="submit" class="btn btn-sm btn-primary">Add Report</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import jQuery from 'jquery'
import DateMixin from "@/mixins/DateMixin"
import { ReportService } from '../../services/ReportService'
import { AlertService } from '../../services/AlertService'
// eslint-disable-next-line no-undef
let $ = jQuery
export default {
  name: 'NewAccidentIncidentReport',
  mixins:[DateMixin],
  data () {
    return {
      newReport: {
        vessel_id: null,
        report_type_id: 1, // 1 since this is accident incident report
        title: '',
        // todo form break
        eventClass: null,
        eventClassImpact: null,
        eventDate: '',
        localTime: '',
        timezone: null,
        is_confidential_report:false,
        managementOffice: null,
        managementCompany: null,
        closeButtonClick : false
      },
    }
  },
  methods: {
    ...mapActions(['getVesselKeys', 'getTimezoneKeys', 'getEventOneKeys','getEventImpactKeys']),
    async addAccidentIncident () {
      if (await AlertService.confirmCreateAlert()) {
        const report = await ReportService.addReport(this.newReport)
        if(report){
          $('body').removeClass('modal-open')
          $('.modal-backdrop').remove()
          $('.fade').remove()
          $('.show').remove()
          // AlertService.successAlert('Adding Accident Incident', 'ADD')

          successAlert.fire({
            title: `ADD ACCIDENT INCIDENT SUCCESS`,
            showConfirmButton: true,
            allowOutsideClick:false,
            allowEnterKey:false,
            allowEscapeKey:false,
            timer: 1500,
            scrollbarPadding: false
          }).then(async (result)=>{
            if(result.isConfirmed){
              await this.$router.push({ name: 'AccidentIncidentReport', params: { id: report.id } }).catch(() => {
              })
            }
          })

          setTimeout(() => this.$router.push({name: 'AccidentIncidentReport', params: {id: report.id}}), 3000);

        }
      }
    },
    async cancelAdd() {
      const response=await AlertService.cancelAlert();
      if(response){
        this.closeButtonClick = true;
        $('#NewAccidentIncident').modal('hide');
        this.newReport={
          vessel_id: null,
          report_type_id: 1,
          title: '',
          eventClass: null,
          eventClassImpact: null,
          eventDate: '',
          localTime: '',
          timezone: null,
        }
        this.closeButtonClick = false;
      }
    },
    changeManagementBranchCompany() {
      this.newReport.managementCompany = null;
      let managementOfficeData = {};
      let managementCompanyData = {};

      managementOfficeData = Object.values(this.mngmntOfficeKeys.filter(item => item.id === this.newReport.managementOffice))[0];
      if (managementOfficeData.hasOwnProperty('management_company_id')) {
        managementCompanyData = Object.values(this.mngmtCompanyKeys.filter(item => item.id === managementOfficeData.management_company_id))[0];
      }

      this.newReport.managementCompany = managementCompanyData.hasOwnProperty('name') ? managementCompanyData.name : null;


    },
    preventModalToCloseInEscKey() {
      $('#NewAccidentIncident').on('hide.bs.modal', (event) => {
        if (this.closeButtonClick === false || this.closeButtonClick === undefined) {
          event.preventDefault();
        }
      });
    },
  },
  async created () {
    await this.getVesselKeys()
    await this.getTimezoneKeys()
    await this.getEventOneKeys()
    await this.getEventImpactKeys()
  },
  mounted() {
    this.preventModalToCloseInEscKey();
  },
  computed: {
    ...mapGetters(['vesselKeys', 'timezoneKeys', 'eventOneKeys','eventImpactKeys','mngmntOfficeKeys','mngmtCompanyKeys'])
  }
}
</script>

<style scoped>

</style>
